
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/scheduler/event-calendar",
      function () {
        return require("private-next-pages/x/api/scheduler/event-calendar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/scheduler/event-calendar"])
      });
    }
  